export const MULTIPART_UPLOAD_ABORTED = 'OSS_MULTIPART_UPLOAD_ABORTED'

export function createMultipartUploadControl () {
  const listeners = []
  const signal = {
    aborted: false,
    addEventListener (eventName, listener) {
      if (eventName === 'abort' && typeof listener === 'function') {
        listeners.push(listener)
      }
    },
    removeEventListener (eventName, listener) {
      if (eventName !== 'abort') {
        return
      }
      const index = listeners.indexOf(listener)
      if (index >= 0) {
        listeners.splice(index, 1)
      }
    }
  }
  return {
    signal,
    abort () {
      if (signal.aborted) {
        return
      }
      signal.aborted = true
      listeners.slice().forEach(listener => listener())
      listeners.length = 0
    }
  }
}

export function createAbortError () {
  const error = new Error('分片上传已取消')
  error.code = MULTIPART_UPLOAD_ABORTED
  return error
}

export function throwIfAborted (signal) {
  if (signal && signal.aborted) {
    throw createAbortError()
  }
}

export function isMultipartUploadAborted (error) {
  return Boolean(error && error.code === MULTIPART_UPLOAD_ABORTED)
}
